import type * as React from 'react'

function LatviaFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.2026 19.8622H1.79742C0.804703 19.8622 0 19.0574 0 18.0647V5.93536C0 4.94264 0.804703 4.13794 1.79742 4.13794H22.2026C23.1952 4.13794 24 4.94264 24 5.93536V18.0647C24 19.0574 23.1953 19.8622 22.2026 19.8622Z"
        fill="#9C1A2C"
      />
      <path d="M24 13.2414H0V10.7586H24V13.2414Z" fill="#FFFFFF" />
      <path
        d="M22.2026 10.7586H1.79742C0.804703 10.7586 0 9.95394 0 8.96123V5.93536C0 4.94264 0.804703 4.13794 1.79742 4.13794H22.2026C23.1952 4.13794 24 4.94264 24 5.93536V8.96123C24 9.95394 23.1953 10.7586 22.2026 10.7586Z"
        fill="#9C1A2C"
      />
    </svg>
  )
}

export default LatviaFlag
